import { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], subtotal: 0, vat_total: 0, total: 0 });

  const isApproved = user && (user.role === "admin" || (user.role === "retailer" && user.status === "approved"));

  const refreshCart = useCallback(async () => {
    if (!isApproved) { setCart({ items: [], subtotal: 0, vat_total: 0, total: 0 }); return; }
    try {
      const { data } = await api.get("/retailer/cart");
      setCart(data);
    } catch { /* noop */ }
  }, [isApproved]);

  useEffect(() => { refreshCart(); }, [refreshCart]);

  const count = cart.items.reduce((n, i) => n + i.quantity, 0);

  const value = useMemo(() => ({ cart, setCart, refreshCart, count }), [cart, refreshCart, count]);

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
